import { jsx as _jsx } from "react/jsx-runtime";
import { classNames, responsiveClassNames } from "../../utilities/props.js";
import Text from "../Text/index.js";
import s from "./Divider.module.css";
const Divider = (props) => {
    const { vertical, blank, children, contentPosition = "center", className, attributes } = props;
    const rootClassNames = classNames(s.root, className, blank && s["--blank"], children ? s[`--content-position-${contentPosition}`] : undefined, ...responsiveClassNames(s, "--vertical", vertical));
    // Only support aria-orientation for non-responsive dividers
    let ariaOrientation;
    if (typeof vertical === "boolean" || vertical === undefined) {
        ariaOrientation = vertical ? "vertical" : "horizontal";
    }
    return (_jsx("div", { ...attributes, role: "separator", "aria-orientation": ariaOrientation, className: rootClassNames, children: children && (_jsx(Text, { color: "neutral-faded", variant: "caption-1", className: s.label, children: children })) }));
};
Divider.displayName = "Divider";
export default Divider;
